module.exports = __webpack_public_path__ + "img/global_man_750_white.a8dbf0ac.png";